import * as React from 'react';

const widgetFilters = window.skodaVariables.widgetFilters;

const loadScript = (scriptId, src) => {
    let promise = new Promise((resolve, reject) => {
        let exists = document.getElementById(scriptId);
        if (exists) resolve();
        var d = new Date();
        var cacheBreaker = d.getUTCMilliseconds();
        const script = document.createElement('script');
        script.src = src + '?v=' + cacheBreaker;
        script.id = scriptId;
        script.type = 'module';
        document.body.appendChild(script);
        script.onload = () => { resolve(); };
        script.onerror = () => { reject(); }
    });
    return promise;
};

const FCContainer = (props) => {
    const [loadError, setLoadError] = React.useState(false);
    const [widget, setWidget] = React.useState(null);
    const [widgetOptions, setWidgetOptions] = React.useState({
        endpoint: props.endpoint,
        containerId: 'finance-calculator',
        bid: widgetFilters.bid,
        culture: widgetFilters.culture,
        filter: {
            mbv: widgetFilters.mbv
        }
    });

    React.useEffect(() => {
        let mounted = true;
        loadScript('fc', props.widget)
            .then(() => {
                let instance = new (window.FinanceCalculator).Widget();
                if (mounted)
                    setWidget(instance);
            })
            .catch((error) => {
                if (mounted)
                    setLoadError(true);
            });
        return () => { mounted = false; };
    }, [props.widget, props.endpoint]);
    if (loadError)
        return React.createElement("h3", null, "Could not load financial products");
    return (React.createElement("div", { id: "financing-calculator" },
        " ",
        !widget && React.createElement("span", null, "...Loading financial products"),
        " ",
        widget && React.createElement(widget.Component, Object.assign({}, widgetOptions)),
        " "));
};


export default FCContainer;